import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
@Component({
  selector: 'app-top-up-balance',
  templateUrl: './top-up-balance.component.html',
  styleUrls: ['./top-up-balance.component.sass']
})
export class TopUpBalanceComponent implements OnInit {
  public subscriber;
  public prepaidBalance;
  public realAmountPlan = 50;
  public otherAmount = 50;
  public token: string = sessionStorage.getItem("token");
  public selectBan;
  public typePayment;
  public address;
  public list;
  public otherMount;
  public typeOption = 1;
  public amount;
  public idProduct;
  public ivuState;
  public info;
  public valueRecharge = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].planInfoField.socRateField;
  public valueRecharge2 = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].planInfoField.socRateField;
  public totalPagar = 0;
  @Output() updateAmount = new EventEmitter;
  @Output() updateIdProduct = new EventEmitter;
  @Output() updateTotalAmount = new EventEmitter;
  @Output() updateTax = new EventEmitter();
  @Output() updateScreenView = new EventEmitter();
  public tax = 0;
  constructor(private loadingScreenService: LoadingScreenService, private services: Service, private global: GlobalService) { }

  ngOnInit() {
    if(sessionStorage.getItem("prepaidBalance")!=null){
      this.prepaidBalance = atob(sessionStorage.getItem("prepaidBalance"));
    }
    else{
      this.prepaidBalance=0;
    }

    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.subscriber = this.global.getSuscriberByDefault(this.selectBan);
    for (let i = 0; i < this.info.length; i++) {
      if (this.info[i].subscriberNumberField == this.subscriber) {
        this.realAmountPlan = this.info[i].planInfoField.socRateField;
      }
    }
    this.paymentMethod();
  }
  paymentMethod() {
    this.loadingScreenService.startLoading();
    this.services.paymentMethod(this.token, this.subscriber).subscribe(data => {
      if (data.success == true) {
        this.typePayment = data.formPaymentTypes;
        this.paymentAddress();
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.error);
      }
    });
  }
  paymentAddress() {
    this.services.paymentAddress(this.token, this.subscriber).subscribe(data => {
      if (data.success == true) {
        this.address = data.address;
        this.rechargeList();
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.error);
      }
    });
  }
  rechargeList() {
    this.services.rechargeList(this.token, this.subscriber, 2).subscribe(data => {
      this.loadingScreenService.stopLoading();
      if (data.success == true) {
        this.list = data.formProducts;
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.error);
      }
    });
  }
  option(sw, sw2, amount, idProduct, ivuState) {
    if(this.global.validateSession()===true){
      this.typeOption = sw2;
      const check_b = document.getElementById('check_b') as HTMLInputElement;
      if (sw2 == 0) {
        this.amount = amount;
        this.idProduct = idProduct;
        this.ivuState = ivuState;
        document.getElementById("option_a").className = "mnts-rcrg ";
        document.getElementById("option_b").className = "mnts-othr-2 vcenter";

        check_b.checked = false;
        for (let i = 0; i < this.list.length - 1; i++) {
          document.getElementById("option_" + i).className = "mnts-rcrg rcrg-a";
        }
        document.getElementById("option_" + sw).className = "mnts-rcrg on rcrg-a"
        const check = document.getElementById("check_" + sw) as HTMLInputElement;
        check.checked = true;
        this.valueRecharge = this.list[sw].productName;
      }
      else if (sw2 == 2) {
        this.amount = this.otherAmount;
        this.idProduct = idProduct;
        this.ivuState = ivuState;
        document.getElementById("option_b").className = "mnts-othr-2-on vcenter";
        check_b.checked = true;
        document.getElementById("option_a").className = "mnts-rcrg ";
        for (var i = 0; i < this.list.length - 1; i++) {
          document.getElementById("option_" + i).className = "mnts-rcrg rcrg-a";
        }
      }
      else {
        this.amount = amount;
        this.idProduct = idProduct;
        document.getElementById("option_a").className = "mnts-rcrg on rcrg-a";
        document.getElementById("option_b").className = "mnts-othr-2 vcenter";
        check_b.checked = false;
        for (let i = 0; i < this.list.length - 1; i++) {
          document.getElementById("option_" + i).className = "mnts-rcrg rcrg-a";
        }
      }
    }
  }
  continuePrepaidRecharge() {
    if (this.global.validateSession() == true) {
      if (this.typeOption == 2 || this.otherMount) {
        this.amount = this.valueRecharge2;
      }
      if (this.amount > 0) {
        if (this.amount >= 5) {
          if (this.amount <= 150) {
            if (this.idProduct != null) {
              this.tax = parseFloat(this.amount) * parseFloat(this.ivuState);
              this.totalPagar = parseFloat(this.amount) + this.tax;
              this.updateAmount.emit(this.amount);
              this.updateIdProduct.emit(this.idProduct);
              this.updateTotalAmount.emit(this.totalPagar);
              this.updateTax.emit(this.tax);
              this.updateScreenView.emit(2);
            }
            else {
              this.global.notif("El producto no tiene codigo.");
            }
          }
          else {
            this.global.notif("El monto no puede ser mayor a $150.00.");
          }
        }
        else {
          this.global.notif("El monto no puede ser menor a $5.00.");
        }
      }
      else {
        this.global.notif("Debe colocar un monto para la recarga.");
      }
    }
  }
}
